<!-- HEADER ============================================= -->
<header id="header" class="header">

    <!-- MOBILE HEADER -->
    <div class="wsmobileheader clearfix">
        <a id="wsnavtoggle" class="wsanimated-arrow"><span></span></a>
        <span class="smllogo"><img src="assets/images/logo (2).png" width="180" height="40" alt="mobile-logo"></span>
        <a href="tel:123456789" class="callusbtn"><i class="fas fa-phone"></i></a>
    </div>

    <!-- HEADER STRIP -->
    <div class="headtoppart bg-blue clearfix">
        <div class="headerwp clearfix">

            <!-- Address -->
            <div class="headertopleft">
                <div class="address clearfix"><span><i class="fas fa-map-marker-alt"></i>18-Shadman Jail Road, Lahore, </span> <a href="tel:+92 3229880088" class="callusbtn"><i
                            class="fas fa-phone"></i>+92 308 7912740
</a>
                </div>
            </div>

            <!-- Social Links -->
            <div class="headertopright">
                <a class="twittericon" title="Instagram" href="https://www.instagram.com/miangpollyclinic?utm_source=qr&igsh=dzkxaGo3cnRpNGgw"><i class="fab fa-instagram"></i> <span
                        class="mobiletext02">Instagram</span></a>
                <a class="facebookicon" title="Facebook" href="https://www.facebook.com/mdclinic4u/"><i class="fab fa-facebook-f"></i> <span
                        class="mobiletext02">Facebook</span></a>
            </div>

        </div>
    </div> <!-- END HEADER STRIP -->


    <!-- NAVIGATION MENU -->
    <div class="wsmainfull menu clearfix">
        <div class="wsmainwp clearfix">

            <!-- LOGO IMAGE -->
            <div class="desktoplogo"><a href="/"><img src="assets/images/logo (2).png" width="180" height="40"
                        alt="header-logo"></a></div>

            <!-- MAIN MENU -->
            <nav class="wsmenu clearfix">
                <ul class="wsmenu-list">
                    <li><a href="/">Home</a></li>
                    <li><a [routerLink]="['/about-us']">About Us</a></li>
                    <li><a [routerLink]="['/departments']" >Departments</a></li> 
                    <li><a [routerLink]="['/contact-us']">Contact</a></li> 
                    <li class="nl-simple header-btn" aria-haspopup="true"><a href="https://wa.me/923087912740">Call Us Now</a></li>
                </ul>
            </nav> <!-- END MAIN MENU -->

        </div>
    </div> <!-- END NAVIGATION MENU --> <!-- END NAVIGATION MENU -->


</header> <!-- END HEADER -->